import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import { createStyles, withStyles } from '@material-ui/core';
import get from 'lodash/get';
import * as React from 'react';
import { matchRoutes } from 'react-router-config';
import { Link } from 'react-router-dom';
import { EventBusService } from '../../services/event-bus.service';
import classnames from 'classnames';

var styles = function styles(theme) {
  return createStyles({
    breadcrumbs: {
      color: theme.palette.secondary.main,
      padding: 25,
      fontSize: 13,
      display: 'flex',
      alignItems: 'center',
      zIndex: 1
    },
    breadcrumbsSlim: {
      padding: theme.spacing(2)
    },
    breadcrumb: {
      marginBottom: 0,
      display: 'inline-block',
      color: theme.palette.secondary.dark,
      textDecoration: 'none',
      '&:before': {
        display: 'inline-block',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        content: '"/"'
      },
      '&:first-child:before': {
        display: 'none'
      }
    },
    breadcrumbActive: {}
  });
};
/**
 * Компонент для хлебных крошек
 * @param props
 * @constructor
 */


var Breadcrumbs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumbs, _React$Component);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumbs).apply(this, arguments));
  }

  _createClass(Breadcrumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      this.eventService$ = EventBusService.on('changeMenu', function () {
        _this.forceUpdate();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          routes = _this$props.routes,
          slim = _this$props.slim;
      var matches = matchRoutes(routes, window.location.pathname);
      return React.createElement("div", {
        className: classnames(classes.breadcrumbs, slim ? classes.breadcrumbsSlim : '')
      }, matches.map(function (route, index) {
        return React.createElement(Link, {
          to: get(route, 'match.url', '/'),
          className: classes.breadcrumb,
          key: "route-".concat(index)
        }, get(route, 'route.label', 'Not found'));
      }));
    }
  }]);

  return Breadcrumbs;
}(React.Component);

export default withStyles(styles, {
  name: 'Breadcrumbs'
})(Breadcrumbs);